<template>
    <div class="record">
        <a :href="PCUrl" class="go-back">返回首页</a>
        <div class="top">
            <img src="../assets/logo.png" alt="">
            <p>PIMC评估您的沟通状态</p>
        </div>
        <div class="box" v-if="!allFinish">
            <div class="video">
                <video autoplay id="camera" style="display:none" muted></video>
                <canvas :width='width' :height='height' id="canvas"></canvas>
                <div class="warn" v-show="!hasFace">
                    <img src="../assets/warn.png" alt="">
                    {{loadingCheckFace?'加载中...':'请对准摄像头'}}
                </div>
            </div>
            <div class="reply">
                <h1>题目{{questionIndex+1}}</h1>
                <div class="audio">
                    <h2>语音</h2>
                    <div class="play" @click="play" v-if="question.length>0">
                        <img :src="audioPlaying?require('../assets/audio.gif'):require('../assets/audio.png')" alt="">
                        <audio :src="question[questionIndex].mp3_path" id="audio" @ended='playEnd' @play='playStart' preload="auto"></audio>
                    </div>
                    <div class="audio-disable" v-if="audioDisabled"></div>
                </div>
                <p class="text">{{questionText}}</p>
                <p class="time-tip">作答时间最多<span>90</span>秒 (已答时间<span>{{second>9?second:'0'+second}}</span>秒)</p>
                <button v-if="recordStatus==1" class="btn yellow" :class="{disable:this.second<10}" @click="stop">作答结束</button>
                <button v-else class="btn blue" :class="{disable:!hasFace||!audioPlayed||audioDisabled}" @click="start">立即作答</button>
            </div>
            <!-- <div class="loading"><img src="../assets/loading.gif" alt=""></div> -->
        </div>
        <div class="box finish" v-else>
            <h1>全部问题完成情况</h1>
            <ul>
                <li v-for="(item,index) in videoProgress" :key="index">
                    <h2>{{index+1}}</h2>
                    <div class="bar"><span :style="{'width':item.rate+'%'}"></span></div>
                    <h3>第{{index+1}}题</h3>
                    <p v-if="item.rate==100">已经上传完成</p>
                    <p v-else>正在上传中...</p>
                </li>
            </ul>
            <div class="finish-btn">
                <button @click="goReport">查看报告</button>
                <button @click="goScene">返回场景</button>
            </div>
            
        </div>
        <div class="exam-bg" v-if="wenjuanShow">
            <div class="exam-box">
                <h1>PIMC Cmind智能沟通反馈系统</h1>
                <h2>产品调研</h2>
                <p>亲爱的Cmind体验官：</p>
                <p style="text-indent: 2em;margin:10px 0">感谢您使用Cmind智能沟通反馈系统，为了给你提供持续得、更优质的服务，诚挚地邀请您填写<a :href="wenjuanUrl" target="blank">《Cmind智能沟通反馈系统用户调研》</a>问卷，您的每一个真是反馈都将被认真对待。</p>
                <p style="text-indent: 2em;">Cmind诚挚地邀请您一起来完成产品的优化和迭代！</p>
                <div class="bt" @click="goWenjuan">马上填写</div>
                <h6 @click="wenjuanCancel">稍后填写，先看报告</h6>
            </div>
        </div>
        <div v-if="wenjuanRightShow" id="idy_floatdiv" style="position:fixed;right:0;top:50px;">
            <a :href="wenjuanUrl" target="blank"><img src="http://www.wenjuan.com/static/images/sharepic/share_pC.png" /></a>
        </div>
        <!-- <video id="v" controls autoplay></video> -->
    </div>
</template>

<script>
import {pico,camvas} from '../assets/js/pico.js'
import { uploadOSS } from '../assets/js/oss'
export default {
  data () {
    return {
        //固定画布高低值
        width:640,height:480,
        hasFace:false,
        loadingCheckFace:true,
        faceInValue:25,//人脸判断值，大于此值则是不存在人脸
        faceOutValue:50,
        pimcencypt:localStorage.pimcencypt,
        encrypt:(this.$route.query.e).replace(/[ ]/g,'+')||'',//user_id和scene_id的加密信息
        scene_id:'',
        user_id:'',
        question:[1],
        questionIndex:0,
        questionText:'',//问题文字
        audio:'',//音频
        audioPlaying:false,
        audioDisabled:false,//音频是否可以点击，播放时不可点击
        audioPlayed:false,//新音频第一次播放完毕
        recorder:'',
        recordStatus:0,
        toastTimer:'',//提示弹窗延时器
        second:0,
        realSecond:0,
        canReply:false,
        timer:'',//录制时间定时器
        videoUsable:false,//录制的视频可不可用
        pimcencypt:localStorage.pimcencypt,
        videoProgress:[],
        allFinish:false,
        wenjuanShow:false,
        wenjuanRightShow:false,
        wenjuanUrl:"https://www.wenjuan.com/s/VjmUZ3/",
    }
  },
  created(){
    //解密：
    let str = this.base64_decode(this.encrypt)
    try{
        let obj = JSON.parse(str)
        console.log(obj)
        if(obj.user_id && obj.scene_id){
            this.user_id = obj.user_id
            this.scene_id = obj.scene_id
        }else{
            alert('地址无效')
            console.log('json格式：',obj)
            return
        }
    }catch(e){
        alert('地址无效')
        console.log('字符为：',str)
        return
    }
    //获取问题
    this.$http.post(`/PcProject/getQuestion?${this.getTime()}`,{
        pimcencypt:this.pimcencypt,
        scene_id:this.scene_id,
        refresh:0
    }).then(res => {
        if(!res.data.code){
            this.question = res.data.data
            for(let i=0;i<this.question.length;i++){
                if(this.question[i].is_record){
                    this.videoProgress.push({file:'',rate:100})
                }else{
                    this.questionIndex = i
                    break;
                }
            }
            setTimeout(()=>{
                this.play()
            },1000)
        }else if(res.data.code==1){
            this.toast('未登录',2000)
        }
    }).catch(err => {
        alert('获取题目失败，请检查网络')
    })
  },
  mounted(){
    this.checkFace()
    navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
    var chunks = [],arr = [];
    navigator.getUserMedia({audio: true,video: true},(stream)=>{
        let video = document.querySelector('#camera');
        video.srcObject = stream;
        this.recorder = new MediaRecorder(stream)
        this.recorder.onstop=(e)=>{
            clearInterval(this.timer)
            if(this.videoUsable){//视频有效
                let index = this.questionIndex
                let blob = new Blob(chunks, {type: 'video/mp4'});
                // document.querySelector('#v').src=URL.createObjectURL(blob);
                let enname = this.question[this.questionIndex].scene_en_name;
                let assess_id = this.question[this.questionIndex].assess_id;
                let video_id = this.question[this.questionIndex].video_id;
                let videoName = this.getVideoName()
                let file = new File([blob],videoName,{type:'video/mp4'});
                console.log('视频'+(this.questionIndex+1)+'录制完成,大小:'+Math.round(file.size/1024)+'k')
                this.videoProgress.push({file:file,rate:0})
                this.$http.post(`/PcProject/getSecurityParam?${this.getTime()}`).then(res => {
                    if(!res.data.code){
                        let config = res.data.data
                        // 上传视频
                        uploadOSS(file,config,'video_dir',(rate)=>{//获取进度
                            this.videoProgress[index].rate = rate
                        }).then((res2)=>{
                            if(!res2.code){//视频上传成功
                                // console.log('视频'+(index+1)+'上传完毕')
                                this.$http.post(`/PcProject/uploadQuestion?${this.getTime()}`,{
                                    pimcencypt:this.pimcencypt,
                                    cover_path: this.shotName,
                                    video_path: res2.path,
                                    total_time: this.realSecond,
                                    video_id: video_id,
                                }).then(res3 => {
                                    if(!res3.data.code){}
                                })
                            }else{//上传失败
                                console.error(res2.msg)
                            }
                        }).catch((err)=>{console.log(err)})
                        // 上传封面
                        uploadOSS(this.shotFile,config,'image_dir',()=>{}).then((res)=>{
                            // console.log('封面'+(index+1)+'上传完毕')
                        })
                        // 下一题
                        if(this.questionIndex==this.question.length-1){
                            this.allFinish = true
                            if(localStorage.wenjuanDone!='1')
                                this.wenjuanShow = true
                        }else{
                            this.questionIndex++
                            this.play()
                        }
                    }else{
                        this.toast(res.data.msg,3000)
                    }
                }).catch(err => {
                    this.toast('网络错误，请重试',1500)
                })
            }
            chunks=[]
        }
        // let size = 0
        this.recorder.ondataavailable = e => {
            chunks.push(e.data);
            // arr.push(e.data)
            // if(size>200000){
            //     size=0
            //     let blob = new Blob(arr, {type: 'video/mp4'});
            //     console.log(blob)
            //     arr=[]
            // }
        }
    },()=>{});
  },
  methods:{
    checkFace(){
        let _this = this
        let tempIn = 0,tempOut = 0;
        var update_memory = pico.instantiate_detection_memory(5); //使用最后5帧的检测
        var facefinder_classify_region = function(r, c, s, pixels, ldim) {return -1.0;};
        var cascadeurl = 'https://raw.githubusercontent.com/nenadmarkus/pico/c2e81f9d23cc11d1a612fd21e4f9de0921a5d0d9/rnt/cascades/facefinder';
        fetch(cascadeurl).then(function(response) {
            response.arrayBuffer().then(function(buffer) {
                var bytes = new Int8Array(buffer);
                facefinder_classify_region = pico.unpack_cascade(bytes);
                _this.loadingCheckFace = false
                console.log('人脸检测模型加载完毕');
            })
        })
        var ctx = document.getElementById('canvas').getContext('2d');
        function rgba_to_grayscale(rgba, nrows, ncols) {//图像灰度化
            var gray = new Uint8Array(nrows*ncols);
            for(var r=0; r<nrows; ++r)
                for(var c=0; c<ncols; ++c)
                    // gray = 0.2*red + 0.7*green + 0.1*blue
                    gray[r*ncols + c] = (2*rgba[r*4*ncols+4*c+0]+7*rgba[r*4*ncols+4*c+1]+1*rgba[r*4*ncols+4*c+2])/10;
            return gray;
        }
        var processfn = function(video, dt) {
            // 将视频帧渲染到画布元素并提取rgba像素数据
            ctx.drawImage(video, 0, 0);
            var rgba = ctx.getImageData(0, 0, _this.width, _this.height).data;
            // prepare input to `run_cascade`
            var image = {
                "pixels": rgba_to_grayscale(rgba, _this.height, _this.width),
                "nrows": _this.height,
                "ncols": _this.width,
                "ldim": _this.width
            }
            var params = {
                "shiftfactor": 0.1, // 将检测窗口移动其大小的10%
                "minsize": 100,     // 脸的最小尺寸
                "maxsize": 1000,    // 脸的最大尺寸
                "scalefactor": 1.1  // 对于多尺度处理：移动到较高的尺度时，将检测窗口调整为10%
            }
            //在帧上运行级联，并将获得的检测聚集在一起。
            //dets 是一个包含（R、C、S、Q）四重粒子的数组
            //（代表行、列、刻度和检测分数）
            var dets = pico.run_cascade(image, facefinder_classify_region, params);
            dets = update_memory(dets);
            dets = pico.cluster_detections(dets, 0.2); // set IoU threshold to 0.2
            // draw detections
            if(dets.length>0){
                tempOut = 0
                for(var i=0; i<dets.length; ++i)
                    if(dets[i][3]>45.0){
                        tempIn = 0
                        _this.hasFace = true
                        // _this.canReply = true
                        // ctx.beginPath();
                        // ctx.arc(dets[i][1], dets[i][0], dets[i][2]/2, 0, 2*Math.PI, false);
                        // ctx.lineWidth = 3;
                        // ctx.strokeStyle = 'red';
                        // ctx.stroke();
                    }else{
                        tempIn++
                        if(tempIn>_this.faceInValue){
                            fail()
                        }
                    }
            }else{
                tempOut++
                if(tempOut>_this.faceOutValue){
                    fail()
                }
            }
            // console.log(tempIn,tempOut)
        }
        new camvas(ctx, processfn);
        function fail(){
            _this.hasFace = false
            if(_this.recordStatus){
                _this.videoUsable = false
                _this.second = 0
                _this.recordStatus = 0
                _this.audioDisabled = false
                _this.faceInValue = 25
                _this.faceOutValue = 50
                _this.recorder.stop();
                _this.toast('因长时间检测不到人像，请重新录制',3000)
            }
        }
    },
    play(){
        this.audio = document.getElementById('audio');
        this.questionText = ''
        let str = this.question[this.questionIndex].question_content
        let i = 0;
        this.audio.load()
        this.audio.oncanplay = ()=>{
            // console.log('当前问题音频时间：'+this.audio.duration+'s')
            this.audio.play()
            let timer = setInterval(()=>{
                if(i<str.length){
                    this.questionText += str.substring(i,i+1)
                    i++
                }else{
                    clearInterval(timer)
                }
            },230)
        }
    },
    playStart(){
        // console.log('开始播放')
        this.audioDisabled = true
        this.audioPlaying = true
    },
    playEnd(){
        // console.log('停止播放')
        this.audioDisabled = false
        this.audioPlaying = false
        this.audioPlayed = true
    },
    start(){
        if(!this.audioPlayed||this.audioDisabled){
            this.toast('请阅读完整问题后作答',2000)
            return
        }else if(!this.hasFace&&this.loadingCheckFace){
            this.toast('加载中，请稍后...',3000)
            return
        }else if(!this.hasFace){
            this.toast('请对准摄像头',2000)
            return
        }
        this.screenShot()
        console.log('问题'+(this.questionIndex+1)+'开始录制')
        this.recorder.start(1000);
        this.audioDisabled = true
        this.recordStatus = 1
        this.faceInValue = 150
        this.faceOutValue = 150
        this.timer = setInterval(()=>{
            if(this.second<90){
                ++this.second
            }else{
                this.stop()
                clearInterval(this.timer)
            }
        },1000)
    },
    stop(){
        if(this.second<10){
            this.toast('至少录制10秒',3000)
            return
        }
        this.realSecond = this.second   //记录当前录制时间
        this.second = 0                 //录制时间重置
        this.recordStatus = 0           //录制状态回到录制前
        this.audioDisabled = false      //
        this.faceInValue = 25           //
        this.faceOutValue = 50
        this.videoUsable = true;        //录制的视频是否有效
        this.recorder.stop();
    },
    getVideoName(){
        var myDate = new Date();
        let month = myDate.getMonth() + 1
        month = month.toString().length > 1 ? month : '0' + month;
        let day = myDate.getDate();
        day = day.toString().length > 1 ? day : '0' + day;
        let year = myDate.getFullYear();
        let h = new Date().getHours();
        h = h.toString().length > 1 ? h : '0' + h;
        let m = new Date().getMinutes();
        m = m.toString().length > 1 ? m : '0' + m;
        let s = new Date().getSeconds();
        s = s.toString().length > 1 ? s : '0' + s;
        let time = ''+year+month+day+h+m+s;

        let enname = this.question[this.questionIndex].scene_en_name;
        let assess_id = this.question[this.questionIndex].assess_id;
        let video_id = this.question[this.questionIndex].video_id;
        return (this.user_id + '_' + enname + '_' + video_id + '_' + assess_id + '_' + time + '.mp4');
    },
    setImageName(){
        var myDate = new Date();
        let month = myDate.getMonth() + 1
        month = month.toString().length > 1 ? month : '0' + month;
        let day = myDate.getDate();
        day = day.toString().length > 1 ? day : '0' + day;
        let year = myDate.getFullYear();
        let h = new Date().getHours();
        h = h.toString().length > 1 ? h : '0' + h;
        let m = new Date().getMinutes();
        m = m.toString().length > 1 ? m : '0' + m;
        let s = new Date().getSeconds();
        s = s.toString().length > 1 ? s : '0' + s;
        let time = '' + year + month + day + h + m + s;

        let enname = this.question[this.questionIndex].scene_en_name;
        let assess_id = this.question[this.questionIndex].assess_id;
        let video_id = this.question[this.questionIndex].video_id;
        return (this.user_id + '_' + enname + '_' + video_id + '_' + assess_id + '_' + time + '.jpg');
    },
    screenShot(){
        var canvas = document.getElementById('canvas')
        let imgUrl = canvas.toDataURL("image/jpeg")
        this.shotName = this.setImageName()
        this.shotFile = new File([canvasUrlToBlob(imgUrl)],this.shotName,{type:'image/jpeg'});
        
        function canvasUrlToBlob(urlData){
            var arr = urlData.split(','), mime = arr[0].match(/:(.*?);/)[1],bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {type:mime});
        }
    },
    goReport(){
        this.$http.post(`/PcProject/getAIReportstatus?${this.getTime()}`,
          {pimcencypt:this.pimcencypt,assess_ids:this.question[0].assess_id}
        ).then(res => {
          if(!res.data.code&&res.data.data[0].ai_status){
            this.$router.push({name: 'report',query: {assess_id:res.data.data[0].assess_id}})
          }else{
            this.toast('报告生成中，请稍后...',3000)
          }
        }).catch(err => {
            this.toast('报告生成中，请稍后...',3000)
        })
    },
    goScene(){
        this.$http.get(`/PcProject/checkLogin?${this.getTime()}`,
          {params:{pimcencypt:this.pimcencypt}}
        ).then(res => {
          if(!res.data.code){
            let obj = {realname:res.data.data.realname,mobile:res.data.data.mobile}
            let str = this.base64_encode(JSON.stringify(obj))
            this.$router.push({name: 'index',query: {u:str}})
          }
        }).catch(err => {
            this.toast('返回失败',1000)
        })
    },
    goWenjuan(){
        localStorage.setItem("wenjuanDone",'1');
        this.wenjuanShow = false
        window.open(this.wenjuanUrl,'_blank'); 
    },
    wenjuanCancel(){
        this.wenjuanShow = false
        this.wenjuanRightShow = true
    },
  }
}
</script>
<style scoped>
/* .record{height: 100%;} */
.video{width: 450px;position: relative;}
video{display: block;width: 100%;margin: 0 auto;background: #000;}
.box{display: flex;padding: 30px;position: relative;}
.loading{
    position: absolute;top:0;left: 0;width: 100%;height: 100%;
    border-radius: 10px;
    /* background:url('../assets/loading.gif') no-repeat; */
    background-position: center;
    background-size: 50px 50px;
}
.loading img{
    position: absolute;left: 50%;top:-50px;
    width: 40px;margin-left: -20px;
}
#canvas{width: 450px;display: block;}
.warn{
    position: absolute;color: #fff;line-height: 44px;
    background: rgba(0,0,0,0.6);width: 120px;
    top: 110px;left: 165px;font-size: 15px;
    border-radius: 4px;
}
.warn img{width: 44px;display: block;margin: 15px auto 0;}
.reply{padding-left:30px;flex: 1;}
.reply h1{color: #2fa4e7;font-size: 24px;}
.audio{display: flex;align-items: center;margin: 30px 0;position: relative;}
.audio h2{color: #2fa4e7;font-size: 20px;margin-right: 22px;line-height: 36px;}
.audio .audio-disable{
    position: absolute;top: 0;left: 52px;width: 110px;
    height: 36px;cursor: not-allowed;
}
.audio .play{
    width: 100px;height: 36px;border-radius: 8px;cursor: pointer;
    background: #2fa4e7;position: relative;text-align: left;
}
.audio .play::before{
    content:'';position: absolute;border-width: 10px;
    top: 13px;left: -10px;width:0;height:0;
    border-top:5px solid transparent;
    border-bottom:5px solid transparent;
    border-right:10px solid #2fa4e7;
}
.audio .play img{width: 24px;margin: 6px 0 0 10px;}
.reply .text{
    text-align: left;font-size: 16px;color: #808080;
    line-height: 22px;height: 66px;padding: 5px 0;
}
.row{display: flex;align-items: center;}
.row .time-box{
    position: relative;width: 40px;height: 40px;
    line-height: 40px;background: #a4a4a4;
    margin-right: 8px;font-size: 26px;
}
.row p{flex: 1}
.row button{
    width: 50px;height: 50px;color: #fff;font-size: 15px;
    background: #2fa4e7;padding: 4px 0;opacity: 0.65;
    border: none;text-align: center;border-radius: 4px;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);margin-left: 8px;
}
.time-tip{
    font-size: 14px;text-align: left;margin-top: 20px;
    height: 36px;line-height: 36px;color: #808080;
}
.time-tip span{color: #2fa4e7;font-size: 18px;}
.btn{
    width: 100%;line-height: 34px;color: #ffffff;
    /* background: rgba(128,128,128,.8);border: 1px solid #949494; */
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);letter-spacing: 2px;
    display: block;text-align: center;border-radius: 4px;
    opacity: 0.8;font-size: 15px;cursor: pointer;

}
.blue{
    background-color: #2fa4e7;border: 1px solid #178acc;
    background-image: linear-gradient(#54b4eb, #2fa4e7 60%, rgba(29,156,229,0.1));
    
}
.yellow{
    background-color: #f3a924;border: 1px solid #e39500;
    background-image: linear-gradient(#f8af2d, #f5a100);
}
.disable{
    background: #a4a4a4;border: 1px solid #808080;cursor: not-allowed;
}

.finish{display: block;}
.finish ul{display: flex;justify-content:center;margin: 60px 0 30px;}
.finish h1{font-size: 24px;color: #57b3e7}
.finish li{margin: 0 20px;width: 75px;}
.finish li h2{
    width: 75px;height: 75px;
    background: url('../assets/video.png') no-repeat;
    background-size: 100% 100%;line-height: 75px;
    font-size: 48px;color: #57b3e7;
}
.finish li .bar{
    height: 4px;background: #fff;margin: 16px 0 6px;
    border: 1px solid #e5e5e5;
}
.finish li .bar span{
    display: block;height: 100%;background: #a6daf7;
    transition: width .2s;width: 0;
}
.finish li h3{font-size: 14px;line-height: 24px;color: #808080;}
.finish li p{font-size: 12px;color: #808080;}
.finish-btn{display: flex;justify-content: center;}
.finish-btn button{
    width: 120px;text-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
    line-height: 36px;border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px;font-size: 14px;margin: 0 20px;
    background:linear-gradient(rgba(255,255,255,.2), rgba(255,255,255,.2) 60%, rgba(229,229,229,.2));
    color: #808080;cursor: pointer;
}
.exam-bg{
    position: fixed;width: 100%;height: 100%;
    background: rgba(0,0,0,0.5);top: 0;left: 0;
    
}
.exam-box{
    width: 500px;background: #fff;position: absolute;
    top:50%;left:50%;transform: translate(-50%,-50%);
    border-radius: 10px;padding: 20px;
}
.exam-box h1{font-size: 24px;font-weight: bold;}
.exam-box h2{font-size: 18px;font-weight: bold;}
.exam-box p{text-align: left;}
.exam-box p a{color: #2fa4e7;text-decoration: none;}
.exam-box p a:hover{text-decoration: underline;}
.exam-box .bt{
    width: 100px;line-height: 32px;background: #2fa4e7;
    color: #fff;font-size: 16px;margin:20px auto 0;
    border-radius: 4px;cursor: pointer;
}
.exam-box h6{font-size: 14px;line-height: 14px;margin-top: 10px;cursor: pointer;;}
.exam-box h6:hover{text-decoration: underline;}
#v{position: absolute;bottom: 10px;left: 10px;width: 300px;}
</style>


// WEBPACK FOOTER //
// src/components/record.vue